import api from 'services/api';
import {
  CustomerPersonalDataApi,
  CustomerPersonalDataDto,
  SaveTaxDataAddressRequest,
  SaveTaxDataRequest,
} from 'services/generated';
import appHelpers from '@utils/app-urls';
import { rootApi } from 'store/root-api';
import { handleErrors } from 'services/helpers';

const API_URL = appHelpers.getEndpointUrl();

const personalDataClient = new CustomerPersonalDataApi(
  undefined,
  new URL(API_URL, process.env.REACT_API_URL).href,
  api,
);
export const personalDataApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    getPersonalData: builder.query<CustomerPersonalDataDto, void>({
      queryFn: () => handleErrors(() => personalDataClient.getPersonalData()),
      providesTags: [{ type: 'CustomerPersonalData' }],
    }),
    createOrUpdateCustomerPersonalData: builder.mutation<
      void,
      CustomerPersonalDataDto
    >({
      queryFn: request =>
        handleErrors(() =>
          personalDataClient.createOrUpdatePersonalData(request),
        ),
      invalidatesTags: [{ type: 'CustomerPersonalData' }],
    }),
    saveCountryOfResidenceTaxData: builder.mutation<void, string>({
      queryFn: countryOfResidence =>
        handleErrors(() =>
          personalDataClient.saveCountryOfResidence(countryOfResidence),
        ),
      invalidatesTags: [{ type: 'CustomerPersonalData' }],
    }),
    saveAddressTaxData: builder.mutation<void, SaveTaxDataAddressRequest>({
      queryFn: address =>
        handleErrors(() => personalDataClient.saveAddress(address)),
      invalidatesTags: [{ type: 'CustomerPersonalData' }],
    }),
    saveCountryOfTaxResidenceTaxData: builder.mutation<void, string>({
      queryFn: countryOfTaxResidence =>
        handleErrors(() =>
          personalDataClient.saveCountryOfTaxResidence(countryOfTaxResidence),
        ),
      invalidatesTags: [{ type: 'CustomerPersonalData' }],
    }),
    saveTaxIdentificationNumberTaxData: builder.mutation<void, string>({
      queryFn: taxIdentificationNumber =>
        handleErrors(() =>
          personalDataClient.saveTaxIdentificationNumber(
            taxIdentificationNumber,
          ),
        ),
      invalidatesTags: [{ type: 'CustomerPersonalData' }],
    }),
    saveTaxData: builder.mutation<void, SaveTaxDataRequest>({
      queryFn: taxData =>
        handleErrors(() => personalDataClient.saveTaxData(taxData)),
      invalidatesTags: [{ type: 'CustomerPersonalData' }],
    }),
  }),
});

export const {
  useGetPersonalDataQuery,
  useCreateOrUpdateCustomerPersonalDataMutation,
  useSaveCountryOfResidenceTaxDataMutation,
  useSaveAddressTaxDataMutation,
  useSaveCountryOfTaxResidenceTaxDataMutation,
  useSaveTaxIdentificationNumberTaxDataMutation,
  useSaveTaxDataMutation,
} = personalDataApi;
